import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wl-account-page',
    template: `
        <div class="gutter-padding">
            <h2>{{ 'GLOBAL.SETTINGS.ACCOUNT.MANAGE_ACCOUNT' | translate }}</h2>
            <abs-linked-accounts></abs-linked-accounts>
        </div>
    `
})
export class AccountSettingsPage {}
